import { useMemo } from "react";

// Deep import (not the `@hightouch/lib/brand-profiles` barrel) so the frontend
// bundle doesn't pull in the rest of the brand-profiles module.
import {
  type ResolvedEmailStyleConfiguration,
  resolveEmailStyleConfiguration,
} from "@hightouch/lib/brand-profiles/settings";

import { useBrandProfilesListQuery } from "src/graphql";

/**
 * Resolve the email style configuration (mobile breakpoint + content width)
 * used to wrap a standalone-rendered email or component for preview / export.
 *
 * Always reads the workspace's default brand profile, regardless of which
 * brand(s) the email or component is assigned to. Returns a fully-resolved
 * config (every field present) so callers can pass it straight to
 * `wrapComponentForStandaloneRender`.
 */
export function useComponentEmailStyleConfig(): ResolvedEmailStyleConfiguration {
  const { data: brandProfiles } = useBrandProfilesListQuery(undefined, {
    select: (d) => d.brand_profiles,
  });

  return useMemo(() => {
    const defaultProfile = (brandProfiles ?? []).find((p) => p.is_default);
    return resolveEmailStyleConfiguration(
      defaultProfile?.email_style_configuration,
    );
  }, [brandProfiles]);
}
